<template>
  <div class="general">
    <table-cadu
      custom
      v-model="selected"
      nameTab="dirigentes"
      :class="$vuetify.breakpoint.xs ? 'dirigentes-mobile' : 'dirigentes'"
      :loading="isLoading"
      :append-icon="'$vuetify.icons.chevron-down'"
      :showCheck="false"
      :showFiltro="false"
      :rows="listaFiltrada"
      :rowsHeader="rowsHeaderComputed"
      :items="['05', '10', '15']"
      :elementsPerPageProp="tamanhoPagina"
      :pagina="pagina"
      :qtPaginas="qtPaginas"
      :qtResultados="qtResultados"
      editar
      :ordemProp="ordem"
      :disabledButtons="[true, true, false, false, false]"
      :arrName="['viewConsultar', 'editConsultar']"
      :showDownload="false"
      :texto="role === 'dirigente' || role === 'admin_brasil' ? '+ adicionar dirigente' : ''"
      :role="role"
      @change-element="changeElement"
      @change-page="(page) => changePage(page)"
      @ordena="(ordem) => ordernaTable(ordem)"
      @clickButton="(obj) => clickItem(obj)"
    />

    <error-modal v-model="showError" :errObj="errObj" />

    <overlay-loading v-model="loadingOverlay" />

    <ModalDirigentes
      @att="getDirigenteTabela"
      ref="modalDirigente"
      v-model="showDirigentes"
      @desativarModal="fecharModalDirigentes"
      :idDirigente="idDirigente"
      :nomeAcao="nomeAcaoDirigentes"
    />
  </div>
</template>

<script>
import ModalDirigentes from './ModalDirigentes'
import Dirigentes from '@/services/Dirigentes/Dirigentes'
import jwtDecode from 'jwt-decode'

export default {
  components: {
    ModalDirigentes
  },
  props: {
    nome: {
      type: String,
      required: false,
      default: ''
    },
    crm: {
      type: [String, Number],
      required: false,
      default: ''
    },
    cpf: {
      type: [String, Number],
      required: false,
      default: ''
    },
    unimedId: {
      type: [String, Number],
      required: false,
      default: ''
    },
    campoPesquisa: {
      type: [String, Number],
      required: false,
      default: ''
    }
  },
  data() {
    return {
      selected: [],
      isLoading: false,
      listaDirigentes: [],
        rowsHeaderBase: [
        { text: 'Tratamento', icon: 'repeat' },
        { text: 'Nome', icon: 'repeat' },
        { text: 'CPF', icon: 'repeat' },
        { text: 'CRM', icon: 'repeat' },
        { text: 'UF do CRM', icon: 'repeat' }
      ],
      pagina: 1,
      qtPaginas: 1,
      qtResultados: 5,
      tamanhoPagina: 5,
      ordem: 'asc',
      ordemStatus: '',
      barraPesquisa: '',
      showDirigentes: false,
      nomeAcaoDirigentes: 'ADICIONAR',
      tokenBearer: localStorage.getItem('tokenBearer'),
      dirigentes: '',
      showError: false,
      errObj: {},
      idDirigente: '',
      role: '',
      loadingOverlay: false
    }
  },
  beforeMount() {
    this.role = jwtDecode(this.tokenBearer).role
    this.dirigentes = new Dirigentes(this.tokenBearer, this.$appConfig.config.API)

    this.getDirigenteTabela()
  },
  computed: {
    isColaboradorDirigente() {
      return this.role === 'colaborador_dirigente'
    },
    rowsHeaderComputed() {
      if (this.isColaboradorDirigente) {
        return this.rowsHeaderBase.filter(h => h.text !== 'CPF')
      }
      return this.rowsHeaderBase
    },
    listaFiltrada() {
      if (!this.isColaboradorDirigente) return this.listaDirigentes
      return this.listaDirigentes.map(({ cpf, ...rest }) => rest)
    }
  },
  methods: {
    async exportar() {
      this.loadingOverlay = true

      await this.promiseGeneric(this.dirigentes, 'exportar', this.getArgs())
        .then((res) => {
          if (res) {
            const content = res.headers['content-disposition']
            const url = window.URL.createObjectURL(new Blob([res.data]))
            const link = document.createElement('a')

            link.href = url
            link.setAttribute('download', content.substring(content.indexOf('"') + 1, content.lastIndexOf('"')))
            document.body.appendChild(link)
            link.click()
          }
        })
        .finally(() => {
          this.loadingOverlay = false
        })
    },
    async fecharModalDirigentes(status) {
      this.showDirigentes = status;
      window.location.reload();
      //await this.$nextTick();
    },
    async getDirigenteTabela() {
      await this.$nextTick()
      this.isLoading = true
      let res = await this.promiseGeneric(this.dirigentes, 'getDirigentes', this.getArgs())
      res = res.data
      this.listaDirigentes = res.conteudo
      this.qtPaginas = res.qtPaginas
      this.qtResultados = res.qtResultados
      this.pagina = res.pagina
      this.isLoading = false
    },
    async promiseGeneric(className, nomeFunc, ...valoresFunc) {
      try {
        return await className[nomeFunc](...valoresFunc)
      } catch (err) {
        this.isLoading = false
        this.showError = true
        this.errObj.status = err.response.status
        this.errObj.error = err.response.data.message
      }
    },
    changeElement(element) {
      this.tamanhoPagina = element
      this.pagina = 1
      this.getDirigenteTabela()
    },
    changePage(page) {
      this.pagina = page.currentPage
      this.getDirigenteTabela()
    },
    ordernaTable({ ordem, index }) {
      this.ordem = ordem
      const ordenacoes = this.isColaboradorDirigente
        ? ['tratamento', 'nome', 'crm', 'estadoCrm']
        : ['tratamento', 'nome', 'cpf', 'crm', 'estadoCrm']
      if (index < ordenacoes.length) {
        this.ordemStatus = ordenacoes[index]
      }
      this.getDirigenteTabela()
    },
    clickItem(obj) {
      const index = obj.index

      switch (obj.type) {
        case 'view':
          this.nomeAcaoDirigentes = 'VISUALIZAR'
          this.idDirigente = this.listaDirigentes[index].id
          break
        case 'edit':
          this.nomeAcaoDirigentes = 'EDITAR'
          this.idDirigente = this.listaDirigentes[index].id
          break
        case 'add':
          this.nomeAcaoDirigentes = 'ADICIONAR'
          this.idDirigente = null
          break
      }

      this.$refs.modalDirigente.start()
    },
    getArgs() {
      let args = this.geradorParams(
        {
          name: 'ordenacao',
          value: this.ordemStatus || ''
        },
        {
          name: 'direcaoOrdenacao',
          value: this.ordem || ''
        },
        {
          name: 'campoPesquisa',
          value: this.campoPesquisa || ''
        },
        {
          name: 'nome',
          value: this.nome || ''
        },
        {
          name: 'crm',
          value: this.crm || ''
        },
        {
          name: 'cpf',
          value: this.cpf || ''
        },
        {
          name: 'unimedId',
          value: this.unimedId || ''
        },
        {
          name: 'pagina',
          value: this.pagina || ''
        },
        {
          name: 'tamanhoPagina',
          value: this.tamanhoPagina || ''
        }
      )
      return args
    },
    geradorParams(...params) {
      let str = ''
      for (let p of params) {
        if (p.value) {
          str += `${p.name}=${p.value}&`
        }
      }
      if (params.length > 0) {
        str = str.substring(0, str.length - 1)
      }
      return str
    }
  }
}
</script>

<style lang="sass">
.general
    color: rgba(0, 0, 0, 0.54)
    font-size: 0.875rem !important
    line-height: 1.375rem !important
    letter-spacing: 0.0071428571em

.dirigentes-mobile > .table-cadu
    padding: 20px 10px !important
    border: none
    border-radius: 0px
    width: 100% !important

.dirigentes > .table-cadu
    border: none
    border-radius: 0px
    width: 100% !important

.dirigentes > .table-cadu > .table > table
    width: 100% !important

.dirigentes-mobile > .table-cadu > .table > table
    width: 100% !important
</style>
